import React, { useState } from "react";
import '../Styles/components.css';
import './CardStyles/CardG.css';
import PopUp from "../PopUps/AddToCart_Popup/PopUp";

const PopupLayout = [{
  des: "none",
  options: "none",
  additional: "none",
  specialInstructions: "block",
}];
const CardG = (props, { children, className, ...restProps }) => {
  const [openModal, setOpenModal] = useState(false);

  const Popup = () => {
    setOpenModal(true);
    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }

  }
  const ClosePopup = () => {
    setOpenModal(false);
    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    document.body.style.overflow = 'unset';
  }

  return (
    <div onClick={Popup} {...restProps} className={`theme-div CardG-div ${className}`}>
      <div className={`theme-div CardG-div-0`}>
        <div className={`theme-div CardG-div-1`}>
          <div className={`theme-div CardG-div-9`}>
            <img className={`theme-img CardG-img`} alt="" src={props.img} />
          </div>
          <div className={`theme-div CardG-div-2`}>
            <div className={`theme-div CardG-div-3`}>
              <div className={`theme-div CardG-div-4`}>
                <h2 className={`theme-h2 CardG-h2`} children={props.name} />
              </div>
              <div className={`theme-div CardG-div-5`}>
                <p className={`theme-p CardG-p`} children={props.des} />
              </div>
            </div>
            <div className={`theme-div CardG-div-6`}>
              <div className={`theme-div CardG-div-7`}>
                <span className={`theme-span CardG-span`} > Rs.{props.price}</span>
              </div>
            </div>
            <div className={`theme-div CardG-div-8`}>
              <button className={`theme-button CardG-button`} type="button">
                +
              </button>
            </div>
          </div>
        </div>
      </div>
      {PopupLayout.map((display) => (
        <PopUp
          key={props.id}
          open={openModal}
          onClose={ClosePopup}
          name={props.name}
          id={props.id}
          price={props.price}
          des={props.des}
          img={props.img}
          displayDes={display.des}
          displayOption={display.options}
          displayAdditional={display.additional}
          displaySpecialInstruction={display.specialInstructions}
        />
      ))}
    </div>
  );
};
CardG.defaultProps = {
  name: "Name",
  price: "Price",
  img: "https://admin.indolj.io/upload/1679987719-12.jpg",
  des: "lorem ipsum "
}

export default CardG;
